<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2 mb-3">Importa Corrispettivo Elettronico (RT)</h3>

<div class="upload-container col-md-6">
    
  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="xmlFile" class="mat-form-field-label mb-3">File XML Corrispettivi:</label>
      
      <div 
        class="drop-zone"
        [class.drop-zone--over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">
        
        <div class="drop-zone-content">
          <mat-icon class="drop-zone-icon">receipt_long</mat-icon>
          
          <div *ngIf="!selectedFile" class="drop-zone-text">
            <p class="mb-1">Trascina qui il file XML del corrispettivo</p>
            <p class="text-muted small">o clicca per selezionarlo</p>
          </div>
          
          <div *ngIf="selectedFile" class="selected-file">
            <mat-icon class="file-icon">description</mat-icon>
            <div class="file-info">
              <strong>{{ selectedFile.name }}</strong>
              <small class="text-muted d-block">
                Dimensione: {{ (selectedFile.size / 1024).toFixed(2) }} KB
              </small>
            </div>
            <button 
              mat-icon-button 
              color="warn"
              (click)="removeFile($event)"
              class="remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <input 
        #fileInput
        type="file" 
        id="xmlFile"
        (change)="onFileSelected($event)" 
        accept=".xml"
        style="display: none"
        required>
      
      <div *ngIf="!selectedFile" class="mt-3">
        <small class="form-text text-muted d-block">
          Seleziona un file XML generato dal tuo Registratore Telematico, poi premi "Importa".
        </small>
        <small class="form-text text-muted d-block mt-1">
          I dati relativi a chiusura giornaliera e IVA verranno estratti automaticamente.
        </small>
      </div>
    </div>

    <div *ngIf="selectedFile && !uploadSuccess" class="mt-3 data-preview-card">
      <p class="data-preview-title">Dati rilevati dal file</p>
      <ul class="list-unstyled mb-0">
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">calendar_today</mat-icon>
          <span class="data-preview-label">Data di emissione</span>
          <strong>{{ closingDate }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">qr_code</mat-icon>
          <span class="data-preview-label">Matricola RT</span>
          <strong>{{ deviceId }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">tag</mat-icon>
          <span class="data-preview-label">Progressivo</span>
          <strong>{{ progressiveNumber }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">pin</mat-icon>
          <span class="data-preview-label">Numero Scontrini</span>
          <strong>{{ nDocs }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">euro</mat-icon>
          <span class="data-preview-label">Totale Lordo</span>
          <strong>€ {{ formatToItalian(totalAmount) }}</strong>
        </li>
      </ul>
    </div>

    <div class="mt-3 form-actions d-flex justify-content-end gap-2">
      <button 
        mat-raised-button
        type="submit" 
        [disabled]="!uploadForm.valid || isUploading || !selectedFile"
        color="primary">
        <mat-icon>{{ isUploading ? 'sync' : 'upload' }}</mat-icon>
        {{ isUploading ? 'Importando...' : 'Importa XML' }}
      </button>
    </div>

    <div *ngIf="uploadProgress > 0" class="progress mt-3">
      <div 
        class="progress-bar" 
        [style.width]="uploadProgress + '%'">
        {{ uploadProgress }}%
      </div>
    </div>

    <div *ngIf="uploadError" class="alert alert-danger mt-3 d-flex align-items-center">
      <mat-icon class="me-2">error</mat-icon>
      {{ uploadError }}
    </div>

    <div *ngIf="uploadSuccess" class="alert alert-success mt-3 shadow-sm">
      <div class="d-flex align-items-center mb-3">
        <mat-icon class="me-2 flex-shrink-0">check_circle</mat-icon>
        <div>
          <strong>Chiusura RT {{deviceId}} importata!</strong>
          <p class="mb-0 small">Il corrispettivo progressivo N.{{progressiveNumber}} è stato registrato correttamente.</p>
        </div>
      </div>

      <div class="d-flex gap-2">
        <button mat-flat-button color="primary" (click)="navigateToCorrispettivi()">
          <mat-icon>list</mat-icon> Lista Corrispettivi
        </button>
        
        <button mat-stroked-button (click)="prepareNewUpload()">
          <mat-icon>refresh</mat-icon> Carica un altro
        </button>
      </div>
    </div>

  </form>
</div>

<div class="pt-5 mt-5"></div>
